import React from "react";
import { Cookies } from 'react-cookie';
import { getForexBasePath, goToLanding } from '.';
import { ADD_PRODUCTS, SUCCESS, UPLOAD_DOCUMENTS, UPDATE_TRIP_PURPOSE, UPDATE_TRAVELLER_DETAILS, UPDATE_TRIP_DETAILS, UPDATE_TRIP_DURATION, DOCUMENT_CONCENT, BMF_UPDATE_ADDRESS, BMF_CONFIRM_ORDER_DETAILS, BMF_ORDER_COMPLETE, BMF_DOCUMENT_UPLOADS, BMF_ORDER_CONFIRMED, BMF_PAYMENT_BEING_CONFIRMED, BMF_PAYMENT_FAILED, ADD_MORE_PRODUCTS, BMF_PAYMENT_CONFIRMED, DEEPLINKS_MAP, ANDROID, MakeMyTrip, GoIbibo, DEEPLINK_PARAM_ORDER_ID, DEVICE_MODEL_TYPE, MMT_FOREX_COOKIE, COOKIES } from '../../../constants';
import { history } from '../../Router';
import UAParser from 'ua-parser-js';
import { ADDRESS_SUBMIT, ADDRESS_SUBMIT_SUCCESS, BMFOptionToCashOrCard, BMF_PRODUCT_COOKIE_KEY, BMF_PROGRAM_COOKIE_KEY, CARDS, CARD_ASSIGNED, CASH, CN, DASHBOARD, DESKTOP, FOREX_BMF_GOIBIBO, FOREX_BMF_MAKEMYTRIP, LANDING_FOREX, MOBILE, PC, PERSONAL_DETAILS, POST_SALES_MMTAPP_VERSION, SELFIE, TRACKING } from './constants';
import dayjs from "dayjs";
import { getUserDeviceOS, isForexListingRolledOut } from "../../../utils/common";
import { FOREX_HAPPAY_GOIBIBO, FOREX_HAPPAY_MAKEMYTRIP } from "./constants";

/* global HyperSnapParams */
/* global HyperSnapSDK */

export const persistSpecificParamInCookie = (specificParamKey, specificParamValue, options = { path: "/" }) => {
    const c = new Cookies();
    c.set(specificParamKey, specificParamValue, options);

}

export const deleteSpecificCookie = (specificParamKey, options = { path: "/" }) => {
    const c = new Cookies();
    c.remove(specificParamKey, options);

}

export const getSpecificCookie = (specificParamKey) => {
    const c = new Cookies();
    return c.get(specificParamKey, { path: '/' });
}

export const callPersistUtmParams = (queryParam) => {
    //const queryParam = new URLSearchParams(props.location.search);
    console.log('----------------Method called callPersistUtmParams-----------------');
    console.log(queryParam);
    let utm_source = queryParam.get('utm_source');
    let utm_medium = queryParam.get('utm_medium');
    let utm_campaign = queryParam.get('utm_campaign');
    let utm_lender = queryParam.get('utm_lender');
    let utm_login = queryParam.get('utm_login');
    let utm_content = queryParam.get('utm_content');
    let bmf_program = queryParam.get(BMF_PROGRAM_COOKIE_KEY);
    let bmf_product = queryParam.get(BMF_PRODUCT_COOKIE_KEY);
    //correct function call syntax
    persistutmParamsInCookie(utm_source, utm_medium, utm_campaign, utm_lender, utm_login, utm_content, bmf_program, bmf_product);
}

export const persistutmParamsInCookie = (utm_source, utm_medium, utm_campaign, utm_lender, utm_login, utm_content, bmf_program, bmf_product) => {
    const c = new Cookies();
    if (!!utm_source && utm_source != null) {
        c.set("utm_source", utm_source, { path: '/' });
    }
    if (!!utm_medium && utm_medium != null) {
        c.set("utm_medium", utm_medium, { path: '/' });
    }
    if (!!utm_campaign && utm_campaign != null) {
        c.set("utm_campaign", utm_campaign, { path: '/' });
    }
    if (!!utm_lender && utm_lender != null) {
        c.set("utm_lender", utm_lender, { path: '/' });
    }
    if (!!utm_login && utm_login != null) {
        c.set("utm_login", utm_login, { path: '/' });
    }

    if (!!utm_content && utm_content != null) {
        c.set("utm_content", utm_content, { path: '/' });
    }

    if (!!bmf_program && bmf_program != null) {
        c.set(BMF_PROGRAM_COOKIE_KEY, bmf_program, { path: '/' });
    }

    if (!!bmf_product && bmf_product != null) {
        c.set(BMF_PRODUCT_COOKIE_KEY, bmf_product, { path: '/' });
    }

}

export const fetchutmParamsFromCookie = () => {
    const c = new Cookies();
    console.log('fetch param from cookie ---------------------');
    let utm_source = c.get("utm_source", { path: '/' });
    let utm_medium = c.get("utm_medium", { path: '/' });
    let utm_campaign = c.get("utm_campaign", { path: '/' });
    let utm_lender = c.get("utm_lender", { path: '/' });
    let utm_login = c.get("utm_login", { path: '/' });
    let utm_content = c.get("utm_content", { path: '/' });
    let bmf_program = c.get(BMF_PROGRAM_COOKIE_KEY, { path: '/' });
    let bmf_product = c.get(BMF_PRODUCT_COOKIE_KEY, { path: '/' });
    console.log(utm_source);
    console.log(utm_medium);
    console.log(utm_campaign);
    console.log(utm_lender);
    console.log(utm_login);
    console.log(utm_content);
    console.log(bmf_program);
    console.log(bmf_product);
    console.log('fetch param from cookie2 ---------------------');
    return { utm_source, utm_medium, utm_campaign, utm_lender, utm_login, utm_content, bmf_program, bmf_product };
}

export const formUrlForRedirection = (utm_source, utm_medium, utm_campaign, utm_lender, utm_login, utm_content, bmf_program, bmf_product) => {
    let urlParam = '';
    if (utm_source) {
        if (!urlParam) {
            urlParam = urlParam + 'utm_source=' + utm_source;
        }
        else {
            urlParam = urlParam + 'utm_source=' + utm_source;
        }
    }
    if (utm_medium) {
        if (!urlParam) {
            urlParam = urlParam + 'utm_medium=' + utm_medium;
        }
        else {
            urlParam = urlParam + '&utm_medium=' + utm_medium;
        }
    }
    if (utm_campaign) {
        if (!urlParam) {
            urlParam = urlParam + 'utm_campaign=' + utm_campaign;
        }
        else {
            urlParam = urlParam + '&utm_campaign=' + utm_campaign;
        }
    }
    if (utm_lender) {
        if (!urlParam) {
            urlParam = urlParam + 'utm_lender=' + utm_lender;
        }
        else {
            urlParam = urlParam + '&utm_lender=' + utm_lender;
        }
    }
    if (utm_login) {
        if (!urlParam) {
            urlParam = urlParam + 'utm_login=' + utm_login;
        }
        else {
            urlParam = urlParam + '&utm_login=' + utm_login;
        }
    }

    if (utm_content) {
        if (!urlParam) {
            urlParam = urlParam + 'utm_content=' + utm_content;
        }
        else {
            urlParam = urlParam + '&utm_content=' + utm_content;
        }
    }

    if (bmf_program) {
        if (!urlParam) {
            urlParam = urlParam + BMF_PROGRAM_COOKIE_KEY + '=' + bmf_program;
        }
        else {
            urlParam = urlParam + '&' + BMF_PROGRAM_COOKIE_KEY + '=' + bmf_program;
        }
    }

    if (bmf_product) {
        if (!urlParam) {
            urlParam = urlParam + BMF_PRODUCT_COOKIE_KEY + '=' + bmf_product;
        }
        else {
            urlParam = urlParam + '&' + BMF_PRODUCT_COOKIE_KEY + '=' + bmf_product;
        }
    }

    return urlParam;
}
export const redirectIntercept = (url, data = null) => {
    let { utm_source, utm_medium, utm_campaign, utm_lender, utm_login, utm_content, bmf_program, bmf_product } = fetchutmParamsFromCookie();
    if (url === '/partners/mmt/forex' || url === '/partners/gi/forex') {
        bmf_product = null;
    }
    let urlParam = formUrlForRedirection(utm_source, utm_medium, utm_campaign, utm_lender, utm_login, utm_content, bmf_program, bmf_product);
    if (!url.includes('utm') || url.includes(BMF_PROGRAM_COOKIE_KEY) || url.includes(BMF_PRODUCT_COOKIE_KEY)) {
        if (url.includes('?')) {
            url = url + "&" + urlParam;
        } else {
            url = url + "?" + urlParam;
        }
    }
    let firstTime;

    if (url.indexOf("/forex?") != -1) {
        firstTime = getSpecificCookie(LANDING_FOREX);
        if (firstTime == "true") {
            url += `&firstTime=false`;
        }
    }

    if (url.indexOf("/tracking") != -1) {
        firstTime = getSpecificCookie(TRACKING);
        if (firstTime == "true") {
            url += `&firstTime=false`;
        }
    }

    if (url.indexOf("/onboarding/personal-details") != -1) {
        firstTime = getSpecificCookie(PERSONAL_DETAILS);
        if (firstTime == "true") {
            url += `&firstTime=false`;
        }
    }

    if (url.indexOf("/onboarding/photo") != -1) {
        firstTime = getSpecificCookie(SELFIE);
        if (firstTime == "true") {
            url += `&firstTime=false`;
        }
    }

    if (url.indexOf("/onboarding/card-assigned") != -1) {
        firstTime = getSpecificCookie(CARD_ASSIGNED);
        if (firstTime == "true") {
            url += `&firstTime=false`;
        }
    }

    if (url.indexOf("/onboarding/update-address") != -1) {
        firstTime = getSpecificCookie(ADDRESS_SUBMIT);
        if (firstTime == "true") {
            url += `&firstTime=false`;
        }
    }

    if (url.indexOf("/onboarding/thank-you") != -1) {
        firstTime = getSpecificCookie(ADDRESS_SUBMIT_SUCCESS);
        if (firstTime == "true") {
            url += `&firstTime=false`;
        }
    }

    if (url.indexOf("/dashboard") != -1) {
        firstTime = getSpecificCookie(DASHBOARD);
        if (firstTime == "true") {
            url += `&firstTime=false`;
        }
    }

    if (url.indexOf("/mismatch") != -1) {
        if (data && data.sub_code)
            url += `&code=${data.sub_code}`
    }
    if (data?.['cta']) {
        history.replace(url, data)
    } else {
        history.replace(url);
    }
}

export const redirectInterceptPush = (url) => {
    console.log('In redirectInterceptPush----------------------');
    let { utm_source, utm_medium, utm_campaign, utm_lender, utm_login, utm_content, bmf_program, bmf_product } = fetchutmParamsFromCookie();
    console.log(utm_source);
    console.log(utm_medium);
    console.log(utm_campaign);
    console.log(utm_lender);
    console.log(utm_login);
    let urlParam = formUrlForRedirection(utm_source, utm_medium, utm_campaign, utm_lender, utm_login, utm_content, bmf_program, bmf_product);

    if (url) {
        if (url.includes('?')) {
            url = url + "&" + urlParam;
        } else {
            url = url + "?" + urlParam;
        }
    }
    if (!url.includes('tm-user-id')) {
        if (url.includes('?')) {
            url = url + "&" + "tm-user-id=" + getParameterByName("tm-user-id");
        } else {
            url = url + "?" + "tm-user-id=" + getParameterByName("tm-user-id");
        }
    }
    history.push(url);
}

export const redirectInterceptHref = (url) => {
    console.log('In redirectInterceptHref----------------------');
    let { utm_source, utm_medium, utm_campaign, utm_lender, utm_login, utm_content, bmf_program, bmf_product } = fetchutmParamsFromCookie();
    console.log(utm_source);
    console.log(utm_medium);
    console.log(utm_campaign);
    console.log(utm_lender);
    console.log(utm_login);
    let urlParam = formUrlForRedirection(utm_source, utm_medium, utm_campaign, utm_lender, utm_login, utm_content, bmf_program, bmf_product);

    if (url) {
        if (url.includes('?')) {
            url = url + "&" + urlParam;
        } else {
            url = url + "?" + urlParam;
        }
    }
    window.location.href = url;
}

export const addUtmTagsToUrl = (url) => {
    if (url) {
        let { utm_source, utm_medium, utm_campaign, utm_lender, utm_login, utm_content } = fetchutmParamsFromCookie();
        if (utm_source || utm_medium || utm_campaign || utm_lender || utm_login || utm_content) {
            let urlParam = formUrlForRedirection(utm_source, utm_medium, utm_campaign, utm_lender, utm_login, utm_content);
            if (url.includes('?')) {
                url = url + "&" + urlParam;
            } else {
                url = url + "?" + urlParam;
            }
        }
    }
    return url;
}

export const getParameterByName = (name) => {
    var match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}

export const randomIntFromInterval = (min, max) => { // min and max included 
    return Math.floor(Math.random() * (max - min + 1) + min)
}

export const getFormattedAmount = (amount, currency, isX100 = false, noDecimals = false, sendPlainString = false) => {
    if (amount == "" || !amount) {
        amount = "0";
    }
    let val = Number(amount).toString();
    if (isX100) {
        val = val.substring(0, val.length - 2) + (!noDecimals ? "." + val.substring(val.length - 2) : "");
    }
    return currency === "INR" ?
        <span><span style={{ fontFamily: "Merriweather, serif", marginRight: "3px" }}>₹</span>{new Intl.NumberFormat('en-IN', { maximumFractionDigits: (noDecimals ? 0 : 2), minimumFractionDigits: 0 }).format(Number(val))}</span> :
        new Intl.NumberFormat('en-IN', { style: 'currency', currency: currency }).format(val);
}

export const formatDateWithSuffix = (date) => {
    const suffix = ["st", "nd", "rd", "th"];
    const dateString = date.toLocaleString("en-US", {
        month: "long",
        year: "numeric",
    });

    const day = date.getDate();
    return `${day}${suffix[day < 4 ? day - 1 : 3]} ${dateString}`;
}

//Call this function with text to be copied, callback for setting a state variable true, then false after removeAfterMilliSecond duration. 
//Use this state variable to show toastmsg
export const copyToClipboard = (text, callback, removeAfterMilliSecond) => {
    navigator.clipboard.writeText(text).then(() => {
        callback(true);
        setTimeout(() => callback(false), removeAfterMilliSecond)
    }, () => {
        callback(false);
    });
}

export const copyToClipboardCustom = (id) => {
    document.getElementById(`${id}`).select();
    document.execCommand('copy');
};

export const removeSlashes = (str) => {
    if (str && str.length > 0) {
        return str.replaceAll(/\//g, " ").replaceAll(/\s+/g, " ");
    }
    return str;
}
export const sendGAEventForInit = (partner, context, user, landedOn, loginStatus) => {
    const label = "loggedIn:" + loginStatus + "-" + context + "-" + partner + "-" + landedOn + "-" + (user && user.data && user.data.userInfo ? user.data.userInfo.userId : "NO_USER_ID_FOUND") + "-" + (user && user.data && user.data.userInfo ? user.data.userInfo.mobile : "NO_MOBILE_FOUND") + "-" + (user && user.data && user.data.loanInfo && user.data.loanInfo.lender ? user.data.loanInfo.lender : "NO_LENDER_ASSIGNED_YET");
    window.dataLayer.push({
        'event': 'eventTracking',
        'category': 'INIT_OTU',
        'action': context,
        'label': label,
        'value': 0
    });
}
export const isSuccessResponse = (response) => response && (response.success || response.responseStatus === SUCCESS);

const redirectPaths = {
    [PC]: {
        [ADD_PRODUCTS]: '/bmf/currency-exchange'
    },
    [CN]: {
        [ADD_PRODUCTS]: '/bmf/currency-exchange'
    }
};

export const redirectToNextState = (nextSignalState, product = CN) => {
    switch (nextSignalState) {
        case ADD_PRODUCTS:
            redirectIntercept(`${getForexBasePath()}${redirectPaths[product][nextSignalState]}`)
            break;

        case UPDATE_TRIP_PURPOSE:
            redirectIntercept(`${getForexBasePath()}/bmf/trip-purpose`)
            break
        case UPDATE_TRAVELLER_DETAILS:
            redirectIntercept(`${getForexBasePath()}/bmf/traveller-details`)
            break
        case UPDATE_TRIP_DETAILS:
            redirectIntercept(`${getForexBasePath()}/bmf/trip-details`)
            break
        case UPDATE_TRIP_DURATION:
            redirectIntercept(`${getForexBasePath()}/bmf/trip-duration`)
            break
        case DOCUMENT_CONCENT:
            redirectIntercept(`${getForexBasePath()}/bmf/doc-info`)
            break
        case BMF_UPDATE_ADDRESS:
            redirectIntercept(`${getForexBasePath()}/bmf/delivery-details`)
            break
        case BMF_CONFIRM_ORDER_DETAILS:
            redirectIntercept(`${getForexBasePath()}/bmf/confirm_order_details`)
            break
        case BMF_ORDER_COMPLETE:
            redirectIntercept(`${getForexBasePath()}/bmf/order-summary`)
            break
        case BMF_DOCUMENT_UPLOADS:
            redirectIntercept(`${getForexBasePath()}/bmf/order-pending`)
            break
            break;
        case UPLOAD_DOCUMENTS:
            redirectIntercept(`${getForexBasePath()}/bmf/order-pending`)
            break;
        case BMF_ORDER_CONFIRMED:
            redirectIntercept(`${getForexBasePath()}/bmf/order-confirmed`)
            break;
        case BMF_PAYMENT_BEING_CONFIRMED:
            redirectIntercept(`${getForexBasePath()}/bmf/order/redirect`)
            break;
        case BMF_PAYMENT_FAILED:
            redirectIntercept(`${getForexBasePath()}/bmf/order-failed`)
            break;
        case ADD_MORE_PRODUCTS:
            redirectIntercept(`${getForexBasePath()}/bmf/currency-exchange-add-money`)
            break;
        case BMF_PAYMENT_CONFIRMED:
            redirectIntercept(`${getForexBasePath()}/bmf/order-pending`)
            break;
        default:
            redirectIntercept(`${getForexBasePath()}/bmf/continue-form`)
    }
}

export const redirectBack = (url) => {
    redirectIntercept(`${getForexBasePath()}/bmf/${url}`);
}

export const parseJSONString = (data) => {
    let parsedData = null;
    try {
        parsedData = JSON.parse(data)
    } catch {
        parsedData = data;
    }

    return parsedData;
}

export const getCurrencyNameFromCode = (currency) => {
    const currencyName = new Intl.DisplayNames(['en'], { type: 'currency' });
    return currencyName.of(currency);
}
export const parseNumber = (val, dec = 0) => Number(parseFloat(val)).toFixed(dec);

export const optionToType = Object.freeze({
    "option-2": "Sell",
    "option-1": "Buy"
});

export const optionToTypeCardCash = Object.freeze({
    [CASH]: "option-2",
    [CARDS]: "option-1"
});

export const optionToProduct = Object.freeze({
    "option-2": "CN",
    "option-1": "PC"
});

export const createAddProductObject = (data, type, addProductRes) => {
    const array = data.data[type];
    if (addProductRes && addProductRes.products && addProductRes.products[type]) {
        data.data[type] = [...array, ...addProductRes.products[type]];
    }

    if (addProductRes && addProductRes.products) {
        data.data = { ...addProductRes.products, ...data.data };
    }

    return data;
}

export const sleep = (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export const checkLocalData = (bmfData, program, redirectBackUrl = "continue-form", landingPageUrl) => {
    if (!bmfData && program) {
        redirectBack(redirectBackUrl);
    } else if (!bmfData && !program) {
        redirectIntercept(`${getForexBasePath()}/bmf/${landingPageUrl}`);
    }
}

export const getValue = (key, obj) => obj && obj[key];

export const transformData = (_data, program) => {
    let toSend = {};
    toSend['skipRedirection'] = _data.skipRedirection;

    let data = _data.data || _data.products;

    let datum = {
        "order_id": data.order_id || data.data.order_id,
        "is_done": _data.is_done !== undefined ? _data.is_done : (_data.data ? _data.data.is_done : false),
        ...(data.cash && { cash: getProductPayload(data.cash) }),
        ...(data.cards && { cards: getProductPayload(data.cards) }),
    }
    toSend['program'] = program;
    toSend['data'] = datum;

    return toSend;
}

const getProductPayload = (data) => {
    if (Array.isArray(data)) {
        return data.map(item => {
            return {
                acq_amount: parseFloat(item.acq_amount),
                acq_curr: item.acq_curr,
                is_active: item.is_active
            }
        })
    }

    return data;
}

export const getNumberOfCards = (data) => (data && data.products && data.products[CARDS] && data.products[CARDS].length) || 0;
export const shouldShowCardsOption = (numberOfCards, data) => (numberOfCards < 1 || (data && data.editDetails && (numberOfCards < 1 || data.editDetails.type === BMFOptionToCashOrCard[CARDS]))) ? true : false;

export const handleEnter = (event) => {
    if (event.keyCode === 13) {
        const form = event.target.form;
        const index = Array.prototype.indexOf.call(form, event.target);
        form.elements[index + 1].focus();
        event.preventDefault();
    }
}

export const goToInrFlowPage = () => {
    redirectIntercept(`${getForexBasePath()}/inr-card`)
}

export const getRupeeSymbol = (amount, showZero) => {
    return <span style={{ fontFamily: "Merriweather" }}>₹ <span style={{ fontFamily: "Poppins" }}>{amount ? amount : (showZero ? "0" : "")}</span></span>
}

export const countDecimals = function (value) {
    let text = value.toString()
    // verify if number 0.000005 is represented as "5e-6"
    if (text.indexOf('e-') > -1) {
        let [base, trail] = text.split('e-');
        let deg = parseInt(trail, 10);
        let baseLength = base.split(".")[1].length;
        return deg + baseLength;
    }
    // count decimals for number in representation like "0.123456"
    if (Math.floor(value) !== value) {
        return value && value.toString() && value.toString().split(".") && value.toString().split(".")[1] &&
            value.toString().split(".")[1].length || 0;
    }
    return 0;
}

export const getRupeeSymbolWithLocale = (amount, showZero) => {
    let value = countDecimals(amount);
    let amt = amount.toLocaleString('en-IN', {
        maximumFractionDigits: value
    });
    return getRupeeSymbol(amt, showZero);
}

export const getLocaleValue = (amount) => {
    let value = countDecimals(amount);
    let amt = amount.toLocaleString('en-IN', {
        maximumFractionDigits: value
    });
    return amt;
}

export const isMobile = function () {
    let check = false;
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
};

export const parseUserAgentBMF = (ua, page, order, user, otherInfo, otherData) => {

    let parser = new UAParser().setUA(ua).getResult();
    let app_version = navigator.userAgent.split("MMT_")[1];
    app_version = `${user && user.partner === MakeMyTrip ? "MMT" : "GI"}_` + app_version;

    console.log(parser);

    const product = otherData?.product;
    delete otherData?.product;

    return {
        "context": {
            "topic_name": "tripmoney_forex_ui",
            "template_id": "34701",
            "client_timestamp": new Date().getTime(),
            "lob_name": "LEN",
            "environment": "prod",
            "funnel_step": product
        },
        "user_details": {
            "zuid": user && user.zuid ? user.zuid : "",
            "puid": user && user.puid ? user.puid : "",
            "partner": user && user.partner ? user.partner : ""
        },
        "device": {
            "latitude": (otherInfo ? otherInfo.lat : ""),
            "longitude": (otherInfo ? otherInfo.long : ""),
            "os": parser && parser.os && parser.os.name ? parser.os.name : "",
            "type": !isMobile() ? "Desktop" : (parser && parser.device && parser.device.type ? parser.device.type : ""),
            "os_version": parser && parser.os && parser.os.version ? parser.os.version : "",
            "app_version": app_version,
            "user_agent": ua,
            "model": window.mmt_android_bridge ? "App" : "Web"
        },
        "page": page,
        "order": {
            "id": order ? order.id : ""
        },
        ...otherData
    }
}

export const getExperimentId = (partner, pokusResponse) => {
    let experimentId = 0;
    if(pokusResponseHandler(pokusResponse, partner)){
        experimentId = (partner === MakeMyTrip) ? 7215 : 1902 
    }
    else experimentId = (partner === MakeMyTrip) ? 7214 : 1901
    return [{
        exp_experiment_variant_id : experimentId
    }]
}

const pokusResponseHandler = (pokusResponse, partner) => {
    // if(isMmtForexRedirect(partner)) return false;
    if(pokusResponse?.data?.status === "enabled" && pokusResponse?.data?.feature_name === 'forex_currency_revamp'){
      return true;
    }
    return false;
}

export const isMmtForexRedirect = (partner) => {
    const backUrl = getSpecificCookie(MMT_FOREX_COOKIE) || false;
    const isApp = window?.app_bridge || window?.mmt_android_bridge;
    const isMmtForexRedirect = backUrl && partner === MakeMyTrip && !isApp;
    return isMmtForexRedirect;
}

/* before using this fn, set type="text" and inputMode="numeric" in input */
export const allowNumericInput = (evt) => {
    evt.currentTarget.value = evt.currentTarget.value.replace(/[^0-9]/g, '');
}

export const handleLandingPageRedirection = (programs, otherData = {}) => {
    if (programs && programs.length && (programs.indexOf(FOREX_BMF_MAKEMYTRIP) != -1 || programs.indexOf(FOREX_BMF_GOIBIBO) != -1)) {
        redirectIntercept(`${getForexBasePath()}`)
    } else {
        if (otherData && otherData.redirectTo) {
            goToLanding(otherData);
        } else {
            goToInrFlowPage();
        }
    }
}

export const addDaysToCurrentDate = (skipDay = "", noDays) => {
    let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    let d = new Date();
    let dayName = days[d.getDay()];
    let now = dayjs();
    let d1 = now.add(`${noDays}`, 'day');
    if (skipDay.toLowerCase() === days[new Date(d1.toString()).getDay()].toLowerCase()) {
        console.log("BABABABA")
        d1 = d1.add(`1`, 'day');
    }
    return {
        date: d1.format("DD"),
        month: d1.format("MMMM"),
        day: days[new Date(d1.toString()).getDay()],
        year: d1.format("YYYY")
    }
}

export const isValidDate = (dateString) => {
    var regEx = /^\d{4}-\d{2}-\d{2}$/;
    return dateString.match(regEx) != null;
}

export const redirectDeeplinks = (deeplink, data = {}) => {

    switch (deeplink) {
        case DEEPLINKS_MAP.LOAD_MONEY:
            redirectIntercept(`${getForexBasePath()}/transaction/load-money`)
            break;
        case DEEPLINKS_MAP.TRANSACTIONS_SETTINGS:
            redirectIntercept(`${getForexBasePath()}/transaction/mode`)
            break;

        case DEEPLINKS_MAP.WITHDRAW_MONEY:
            redirectIntercept(`${getForexBasePath()}/transaction/withdraw`)
            break;

        case DEEPLINKS_MAP.CARD_DELIVERY_TRACKING:
            redirectIntercept(`${getForexBasePath()}/tracking`)
            break;

        case DEEPLINKS_MAP.BMF_CARD:
            redirectIntercept(`${getForexBasePath()}/bmf/continue-form?${BMF_PROGRAM_COOKIE_KEY}=${data?.partner === MakeMyTrip ? FOREX_BMF_MAKEMYTRIP : FOREX_BMF_GOIBIBO}&${BMF_PRODUCT_COOKIE_KEY}=${PC}`);
            break;

        case DEEPLINKS_MAP.BMF_CURRENCIES:
            redirectIntercept(`${getForexBasePath()}/bmf/continue-form?${BMF_PROGRAM_COOKIE_KEY}=${data?.partner === MakeMyTrip ? FOREX_BMF_MAKEMYTRIP : FOREX_BMF_GOIBIBO}&${BMF_PRODUCT_COOKIE_KEY}=${CN}`);
            break;
        case DEEPLINKS_MAP.RELOAD_TRACK_ORDER:
            redirectInterceptHref(`mweb/partners/${data?.partner}/forex/bmf/dashboard?deeplink=${DEEPLINKS_MAP.RELOAD_TRACK_ORDER}`);
            break;
        case DEEPLINKS_MAP.RELOAD_LOAD_CURRENCY:
            redirectInterceptHref(`mweb/partners/${data?.partner}/forex/bmf/loadCurrency?deeplink=${DEEPLINKS_MAP.RELOAD_LOAD_CURRENCY}&${DEEPLINK_PARAM_ORDER_ID}=${data?.orderId}`);
            break;
        case DEEPLINKS_MAP.RELOAD_UPLOAD_DOCS:
            redirectInterceptHref(`mweb/partners/${data?.partner}/forex/bmf/uploadDocs?deeplink=${DEEPLINKS_MAP.RELOAD_UPLOAD_DOCS}&${DEEPLINK_PARAM_ORDER_ID}=${data?.orderId}`);
            break;
        case DEEPLINKS_MAP.BMF_TRAVELLER_DETAILS:
            redirectInterceptHref(`partners/${data?.partner}/forex/bmf/onboarding/traveller-details${data?.orderId ? "?" + DEEPLINK_PARAM_ORDER_ID + "=" + data?.orderId : ""}`);
            break;
        case DEEPLINKS_MAP.BMF_LOAD_CURRENCY:
            redirectInterceptHref(`partners/${data?.partner}/forex/bmf/onboarding/load-currency${data?.orderId ? "?" + DEEPLINK_PARAM_ORDER_ID + "=" + data?.orderId : ""}`);
            break;
        case DEEPLINKS_MAP.BMF_ONBOARDING_LANDING:
            redirectInterceptHref(`partners/${data?.partner}/forex/bmf/onboarding/landing`);
            break;
        case DEEPLINKS_MAP.RELOAD_DASHBOARD:
            redirectInterceptHref(`mweb/partners/${data?.partner}/forex/bmf/dashboard?deeplink=${DEEPLINKS_MAP.RELOAD_DASHBOARD}&${DEEPLINK_PARAM_ORDER_ID}=${data?.orderId}`);
            break;
        case DEEPLINKS_MAP.BMF_ORDER_SUBMITTED:
            redirectInterceptHref(`mweb/partners/${data?.partner}/forex/bmf/documentSubmit?deeplink=${DEEPLINKS_MAP.BMF_ORDER_SUBMITTED}&${DEEPLINK_PARAM_ORDER_ID}=${data?.orderId}`);
            break;
        default:
            if (isForexListingRolledOut()) {
                redirectInterceptHref(`${getForexBasePath()}/listing`)
            } else {
                redirectInterceptHref(`${getForexBasePath()}/landing`);
            }


    }


}

export const formatISODate = (date) => {
    if (date) {
        let newDate = new Date(date);
        const day = newDate.toLocaleString('default', { day: '2-digit' });
        const month = newDate.toLocaleString('default', { month: 'long' });
        const year = newDate.toLocaleString('default', { year: 'numeric' });
        return `${day} ${month} ${year}`;
    }
    return "-";
};
const isHigherVersion = (installAppVersion, hvergeVersion) => {
    try {
        const oldParts = hvergeVersion.split('.')
        const newParts = installAppVersion.split('.')
        for (var i = 0; i < newParts.length; i++) {
            const a = parseInt(newParts[i]); // parse int
            const b = parseInt(oldParts[i]); // parse int
            if (i + 1 == newParts.length && a === b) return true;
            if (a > b) return true;
            if (a < b) return false;
        }
        return false;
    } catch (e) {
        console.error("Fail check isHigherVersion", e);
        return false;
    }
}

// return {v_code: '651, v_name: '8.8.7'}
export const getMmtAndroidVersion = () => {
    const version = window?.mmt_android_bridge?.getAppVersion();
    let mmtAndroidAppVersion = {};
    if (version) {
        try {
            mmtAndroidAppVersion = JSON.parse(decodeURIComponent(version))
        } catch (e) {
            console.error(`Error parsing app version. Got version: ${version}`, e);
        }
    }
    return mmtAndroidAppVersion;
}

export const getGIAndroidVersion = () => {
    const version = window?.app_bridge?.getAppVersion?.();
    if (version?.length) {
        return version;
    } else {
        return '';
    }
}

export const getGIIOSVersion = () => {
    const version = window?.app_bridge?.getAppVersion?.();
    return version?.length ? version : '';
}

export const getInstalledVersion = (partner) => {
    return partner === MakeMyTrip ?
        (getUserDeviceOS() === ANDROID ? getMmtAndroidVersion()?.v_name : {}.v_name || '') :
        // FOR GI
        (getUserDeviceOS() === ANDROID ? getGIAndroidVersion() : getGIIOSVersion());
}
// partner -> mmt/gi, os -> android,ios
const isFlowEnabled = (hvergeConfig, partner, os) => {
    let installAppVersion = getInstalledVersion(partner);
    return hvergeConfig?.[`${partner}_${os}`]?.is_enabled ?
        (!hvergeConfig?.[`${partner}_${os}`]?.version?.length ? true : isHigherVersion(installAppVersion, hvergeConfig?.[`${partner}_${os}`]?.version))
        : false;
}

export const isHypervergeFlow = (config, partner) => {
    const hvergeConfig = config?.forex?.hvergeConfig;
    // check for app
    if (window.mmt_android_bridge) {
        if (partner === MakeMyTrip || partner === GoIbibo) {
            return isFlowEnabled(hvergeConfig, partner, getUserDeviceOS());
        } else {
            return false;
        }
    } else if (hvergeConfig?.web_enabled) {
        return true;
    } else {
        return false;
    }
}

export const isHvScriptLoaded = () => {
    return (typeof (HyperSnapParams) !== 'undefined' && typeof (HyperSnapSDK) !== 'undefined');
}

export const shareLink = async (title, text, url, fn) => {
    const data = {
        title,
        text,
        url
    }
    if (navigator?.canShare) {
        try {
            await navigator?.share(data);
        } catch (e) {
            fn && fn();
        }
    } else {
        fn && fn();
    }
}

export const getAndroidOSVersion = (ua) => {
    ua = (ua || navigator.userAgent).toLowerCase();
    var match = ua.match(/android\s([0-9\.]*)/i);
    return match ? match[1] : undefined;
};

export const canNavigateToPostSales = (partner) => {
    if (getUserDeviceOS() !== ANDROID) {
        return true;
    } else {
        if (partner === GoIbibo) {
            return true;
        }
        else if (isHigherVersion(getInstalledVersion(partner), POST_SALES_MMTAPP_VERSION)) {
            return true;
        }
        return parseInt(getAndroidOSVersion(), 10) < 13;
    }
}

export const getDeviceType = () => {
    // @ts-ignore
    if (window.mmt_android_bridge || window.app_bridge) {
        return DEVICE_MODEL_TYPE.APP;
    }
    return DEVICE_MODEL_TYPE.WEB;
};

const getDeviceIdWeb = (partner) => {
    switch (partner) {
        case MakeMyTrip:
            return getSpecificCookie(COOKIES.MMT_DEVICE_ID) || null;
        case GoIbibo:
            return getSpecificCookie(COOKIES.GI_DEVICE_ID) || null;
        default:
            return null;
    }
};

const getDeviceIdApp = () => {
    return window?.app_bridge?.deviceId?.() || null;
}

export const getDeviceId = (partner) => {
    const deviceType = getDeviceType();
    if (deviceType === DEVICE_MODEL_TYPE.WEB) {
        return getDeviceIdWeb(partner);
    } else if (deviceType === DEVICE_MODEL_TYPE.APP) {
        return getDeviceIdApp();
    }
    return null;
};

export const getDeviceDetailsObject = (
    ua,
    partner
) => {
    const parser = new UAParser().setUA(ua).getResult();
    let app_version = navigator.userAgent.split('MMT_')[1];
    app_version = `${partner === MakeMyTrip ? 'MMT' : 'GI'}_` + app_version;
    return {
        id: getDeviceId(partner),
        os: parser && parser.os && parser.os.name ? parser.os.name : '',
        type: !isMobile()
            ? DESKTOP
            : parser && parser.device && parser.device.type
            ? parser.device.type
            : MOBILE,
        os_version:
            parser && parser.os && parser.os.version ? parser.os.version : '',
        app_version: app_version || null,
        user_agent: ua,
        model: getDeviceType() || null,
    };
};